import Renderer from "../Renderer";
import Utils from "../utils/Utils";

/**
 *
 *
 * @author Jaap
 * @date 28-11-2019
 */
export default class SpreadsPanel {
    constructor(panelElement) {
        this.spreadsPanel = panelElement;
        this.spreadTemplate = document.getElementById("HB-sidemenu-spreads").innerHTML;

        this.spreadsPanel.addEventListener("click", (event) => this.spreadClicked(event));
    }

    renderSpreads(spreads, issue) {
        let html = Renderer.renderSource(this.spreadTemplate, {
            issue_title: issue.issue_title,
            js_spreads: spreads,
            overviewEnabled: window.interface_settings?.settings?.overview_enabled,
            backToOverviewText: window.interface_settings?.settings?.text?.sidemenu?.spreads?.overview,
        });
        Renderer.nativeInject(this.spreadsPanel, html);

        return true;
    }

    spreadClicked(event) {
        let target = event.target;
        if (target.dataset && target.dataset.navspread) {
            event.preventDefault();
            event.stopPropagation();
            window.dispatchEvent(
                Utils.createEvent("MaglrHistoryPush", {
                    detail: { issueId: target.dataset.navissue, spreadId: target.dataset.navspread },
                }),
            );
        }
    }

    getPanelElement() {
        return this.spreadsPanel;
    }
}
